import {
  createClient,
  DeepgramClient,
  LiveSchema,
  ListenLiveClient,
} from '@deepgram/sdk';

import { getDeepgramAccessToken } from '@/services/deepgram-service';

const DEEPGRAM_WS_HOST = 'deepgram.com';

function withBearerWebSocketAuth<T>(accessToken: string, run: () => T): T {
  const OriginalWebSocket = window.WebSocket;

  class DeepgramWebSocket extends OriginalWebSocket {
    constructor(url: string | URL, protocols?: string | string[]) {
      if (String(url).includes(DEEPGRAM_WS_HOST)) {
        super(url, ['bearer', accessToken]);
        return;
      }

      super(url, protocols);
    }
  }

  window.WebSocket = DeepgramWebSocket as typeof WebSocket;

  try {
    return run();
  } finally {
    window.WebSocket = OriginalWebSocket;
  }
}

export async function createDeepgramLiveListen(
  options: LiveSchema
): Promise<ListenLiveClient> {
  const accessToken = await getDeepgramAccessToken();

  return withBearerWebSocketAuth(accessToken, () => {
    const client: DeepgramClient = createClient(accessToken);
    return client.listen.live(options);
  });
}

export async function getDeepgramAuthorizationHeader(): Promise<string> {
  const accessToken = await getDeepgramAccessToken();
  return `Bearer ${accessToken}`;
}
